import {
  loadMentionMeForPurchase,
} from "apps/website/utils/load-mention-me-for-purchase";

import { PostCheckoutMentionMeTrigger, TriggerHandler } from "../types";

export const mentionMeHandler: TriggerHandler<PostCheckoutMentionMeTrigger> = (
  _,
  context,
  trigger,
) => {
  console.log("in mentionMeHandler");
  const data = context.sources?.getPostCheckoutCharges;

  if (!data) {
    return false;
  }

  const katkinCustomerId = context.query.get("katkinCustomerId");

  if (!katkinCustomerId) {
    return false;
  }

  const { firstCharge } = data;

  loadMentionMeForPurchase(
    firstCharge,
    katkinCustomerId,
    trigger.enablePopup,
  );

  return true;
};
